import { type EnvironmentProviders, inject, NgModule, type Provider, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AbstractEnvironmentService } from './services/environment/abstract-environment.service';

// Loads the environment asynchronously. Angular will wait for the observable to complete.
const loadEnvironment = (environmentService: AbstractEnvironmentService) => () => environmentService.readEnvironmentFile();

/**
 * simple provider for base config
 */
export function provideConfigModule(): Array<Provider | EnvironmentProviders> {
    return [
        provideAppInitializer(() => {
            const initializerFn = (loadEnvironment)(inject(AbstractEnvironmentService));

            return initializerFn();
        }),
        provideHttpClient(withInterceptorsFromDi()),
    ];
}

@NgModule({
    imports: [], providers: provideConfigModule(),
})
export class ConfigModule {
}
